import { render, staticRenderFns } from "./veStuLiteraryActive.vue?vue&type=template&id=185481f1&scoped=true"
import script from "./veStuLiteraryActive.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryActive.vue?vue&type=script&lang=js"
import style0 from "./veStuLiteraryActive.vue?vue&type=style&index=0&id=185481f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185481f1",
  null
  
)

export default component.exports